export default (palette, isDarkMode) => ({
  '@global': {
    '.img-icon-invert-dark': {
      filter: isDarkMode ? 'invert(1) brightness(1.5)' : 'none',
      transition: 'filter 0.3s ease',
    },
    '.img-icon-dim-dark': {
      filter: isDarkMode ? 'brightness(0.8)' : 'none',
      transition: 'filter 0.3s ease',
    },
  },
})
